module.exports = __webpack_public_path__ + "img/user.413f6602.png";